<template>
  <div class="positionfixed">
    <Header></Header>
    <div class="pc_all FreeCreation">
      <div class="pc_all_content">
        <div class="FreeCreationNav animate__animated animate__fadeInDown" style="animation-delay: 0.2s">
          <div class="FreeCreationNav_btn">
            <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20 active">
              <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
            </router-link>
            <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20">
              <span class="iconfont icon-fa-buysellads"></span>字母LOGO
            </router-link>
            <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20">
              <span class="iconfont icon-AItongkuan"></span>同款创作
            </router-link>
          </div>
        </div>
        <div class="SelectIndustry">
          <div v-for="(industry, index) in industries" :key="index"
            class="SelectIndustry_list animate__animated animate__fadeInDown"
            :style="{ animationDelay: industry.animationDelay + 's' }"
            :class="{ active: selectedIndex == industry.id && !isOtherIndustryActive }"
            @click="selectIndustry(industry.id)">
            <div class="SelectIndustry_list_left font20">
              <div class="list_left_icon iconfont" :class="industry.icon" :style="{ background: industry.color }"></div>
              {{ industry.name }}
            </div>
            <div class="SelectIndustry_list_right"></div>
          </div>

          <div class="StyleColor_bottomcolor animate__animated animate__fadeInDown on" style="animation-delay: 0.6s"
            :class="{ active: isOtherIndustryActive }">
            <div class="StyleColor_bottomcolor_left font18"><span></span>其他：</div>
            <div class="StyleColor_bottomcolor_right">
              <input type="text" placeholder="请输入其他行业" class="font20" v-model="otherIndustry" @input="handleInput" />
            </div>
          </div>
        </div>
        <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 0.4s">
          <router-link to="/ailogo/EnterBrand/EnterBrand" class="Btn_prev font20" @click="goBack">
            <span class="iconfont icon-xiangyou"></span>上一步
          </router-link>
          <div :class="['Btn_next font20', { active: isNextActive }]" @click="goToFreeCreation">
            <div class="form_btn_po">继续<span class="iconfont icon-xiangyou"></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      industries: [],
      selectedIndex: null,
      otherIndustry: '',
      isOtherIndustryActive: false,
      isNextActive: false // 控制 Btn_next 的 active 状态
    }
  },
  components: {
    Header
  },
  created() {
    this.getIndustries(); // 在组件创建时调用获取行业的方法
    // 从 本地获取数据
    this.loadFromLocalStorage();
  },
  methods: {

    ...mapActions(['updateSelectedIndustryId', 'updateOtherIndustry']),

    async getIndustries() {
      try {
        const res = await this.axios.get(`api/LogoInfo/industryList`);
        if (res.code === 1) {
          this.industries = res.result.map((industry, index) => ({
            id: industry.id,
            name: industry.name_cn,
            icon: industry.icon, // 这里可以根据实际数据动态设置
            color: industry.color, // 这里可以根据实际数据动态设置
            animationDelay: (0.11 + index * 0.01) // 递增逻辑
          }));
          console.log("处理后的行业数据:", this.industries);
        } else {
          console.error("接口返回错误:", res);
        }
      } catch (error) {
        console.error("获取行业时出错:", error);
      }
    },
    selectIndustry(index) {

      this.selectedIndex = index
      this.isOtherIndustryActive = false
      this.otherIndustry = ''
      this.isNextActive = true // 激活“继续”按钮

      // 存储选中的行业 ID
      const selectedIndustryId = index;
      this.updateSelectedIndustryId(selectedIndustryId);
      //清空 Vuex 中的其他行业
      this.updateOtherIndustry('');

      //将选中的行业 ID 存储到 localStorage
      localStorage.setItem('logoSelectedIndustryId', selectedIndustryId);
      //清空 localStorage 中的其他行业
      localStorage.setItem('logoOtherIndustry', '');

    },

    handleInput() {
      this.isOtherIndustryActive = this.otherIndustry.trim() !== ''
      if (this.isOtherIndustryActive) {
        this.selectedIndex = null
        this.updateOtherIndustry(this.otherIndustry); // 将输入存储到 Vuex

        //将输入存储到 localStorage
        localStorage.setItem('logoOtherIndustry', this.otherIndustry);

        //清空 Vuex 中的选中行业
        this.updateSelectedIndustryId(0);
        //清空 localStorage 中的选中行业
        localStorage.setItem('logoSelectedIndustryId', 0);

      } else {
        this.updateOtherIndustry(''); // 如果输入为空，清空 Vuex 状态
        //如果输入为空，清空 localStorage
        localStorage.setItem('logoOtherIndustry', '');
      }
      this.isNextActive = this.isOtherIndustryActive || this.selectedIndex !== null
    },

    goToFreeCreation() {
      if (this.isNextActive) {
        this.$emit('increase-progress')
        this.$router.push('/ailogo/FreeCreation/StyleColor')
      }
    },
    goBack() {
      this.$emit('decrease-progress')
      this.$router.push({ name: 'EnterBrand' })
    },

    // 从 本地获取数据
    loadFromLocalStorage() {
      // 从 localStorage 获取选中行业 ID
      const logoSelectedIndustryId = localStorage.getItem('logoSelectedIndustryId');

      // 如果存的是字符串，需要转成数字比较更准确
      // 比如 localStorage 返回 '2'，这里转成 number 做后续逻辑判断
      if (logoSelectedIndustryId) {
        this.selectedIndex = Number(logoSelectedIndustryId);
      }

      // 从 localStorage 获取其他行业
      const logoOtherIndustry = localStorage.getItem('logoOtherIndustry');
      if (logoOtherIndustry && logoOtherIndustry.trim() !== '') {
        this.otherIndustry = logoOtherIndustry;
        this.isOtherIndustryActive = true;
      }

      // 如果本地存储中有选中行业，或者有输入其他行业，则将按钮激活
      // 这里可以根据实际逻辑进行判断
      if (this.selectedIndex || this.isOtherIndustryActive) {
        this.isNextActive = true;
      }
    }
  }
}
</script>


<style>
@import "FreeCreation.css";
</style>
